import React, { Component } from 'react';
import './Bubble.css';
import Loader from '../Loader';
import getClientWidth from '../../functions/getClientWidth';
import arrowImg from './arrow.svg';
const CSS_ANIMATE_DURATION = 500;

class Bubble extends Component {
  constructor(context, props) {
    super(context, props);
    this.state = {init: false, visible:false, loading: false, loaded: false, animated: false, height: 0, width: 0};
  }
  componentDidMount() {
    let { img } = this.props;
    let textLength = img ? 10 : this._content.textContent.length;
    let writeTimeout = Math.log(textLength) * 400; // 540
    this.setState({
      ...this.state,
      init: true,
      height: this._bubble.scrollHeight,
      width: getClientWidth(this._bubble),
      contentWidth: getClientWidth(this._content),
    });
    setTimeout(function(){this.setState({...this.state, visible: true})}.bind(this), CSS_ANIMATE_DURATION);
    setTimeout(function(){this.setState({...this.state, loading: true})}.bind(this), CSS_ANIMATE_DURATION + 300);
    setTimeout(function(){this.setState({...this.state, loaded: true})}.bind(this),
    CSS_ANIMATE_DURATION + 300 + writeTimeout);
    setTimeout(function(){
      this.setState({...this.state, animated: true});
      if (this.props.onAnimated) this.props.onAnimated();
    }.bind(this), CSS_ANIMATE_DURATION + 300 + writeTimeout + CSS_ANIMATE_DURATION + 100);
  }

  render() {
    let { text, img, type, link } = this.props;
    let { init, visible, loading, loaded, animated, width, height, contentWidth } = this.state;
    let style = {};
    if (loaded) style = {width: width + 'px', height: height + 'px'};
    if (animated) style = {width: 'auto', height: 'auto'};
    let bubbleClassName = 'Bubble';
    bubbleClassName += ' Bubble--' + type;
    bubbleClassName += link ? ' Bubble--link': '';
    bubbleClassName += img ? ' Bubble--img': '';
    bubbleClassName += init ? ' Bubble--init' : '';
    bubbleClassName += visible ? ' Bubble--visible' : '';
    bubbleClassName += loaded ? ' Bubble--loaded' : '';
    bubbleClassName += animated ? ' Bubble--animated' : '';
    let lineStyle = {};
    if (loaded) lineStyle = {height: height + 'px'};
    if (animated) lineStyle = {height: 'auto'};
    let lineClassName = 'Bubble__line';
    lineClassName += ' Bubble__line--' + type;
    lineClassName += link ? ' Bubble__line--link': '';
    lineClassName += visible ? ' Bubble__line--init': '';
    lineClassName += loaded ? ' Bubble__line--loaded' : '';
    lineClassName += animated ? ' Bubble__line--animated' : '';
    let contentStyle = !animated ? {width: contentWidth + 'px'} : {};
    let bubbleLoader = init ? <div className="Bubble__loader"><Loader visible={visible} on={loading}/></div> : null;
    let bubbleContent = <div className="Bubble__content" style={contentStyle} ref={(c) => {this._content = c}}>
        {text ? text : null}
        {img ? img : null}
      </div>;

    return (
      <div className={lineClassName} style={lineStyle}>
        {link ?
          <a href={link} target="_blank" className={bubbleClassName} style={style} ref={(b) => {this._bubble = b}}>
            {bubbleLoader}
            {bubbleContent}
          </a> :
          <div className={bubbleClassName} style={style} ref={(b) => {this._bubble = b}}>
            {bubbleLoader}
            {bubbleContent}
          </div>
        }
        {link ? <a href={link} target="_blank" className="Bubble__arrow"><img src={arrowImg} alt="Link"/></a> : null}
      </div>
    );
  }
}

export default Bubble;



/** WEBPACK FOOTER **
 ** ./src/components/Bubble/index.js
 **/